/* eslint-disable @typescript-eslint/no-explicit-any */
 
/* eslint-disable no-useless-catch */
import { api } from "../api";

export interface ValidateEmailTelefoneResponse {
  email: boolean;
  telefone: boolean;
}

export class CadastroService {
  async validateCPF(cpf: string) {
    try {
      const hasByCPF = await api.get(`/tutores/search/${cpf}`);

      if (hasByCPF?.data?.id) {
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }

  async createTutor(data: any) {
    try {
      const response = await api.post("/tutores", data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async createONG(data: any) {
    try {
      const response = await api.post("/ongs", data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  async TutorvalidateEmailTelefone(
    email: string,
    telefone: string
  ): Promise<ValidateEmailTelefoneResponse> {
    try {
      const response = await api.post<ValidateEmailTelefoneResponse>(
        `/tutores/validator`,
        { email, telefone }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async ONGvalidateEmailTelefone(email: string, telefone: string) {
    try {
      const response = await api.post<ValidateEmailTelefoneResponse>(
        `/tutores/validator`,
        { email, telefone }
      );

      return response;
    } catch (error) {
      throw error;
    }
  }
  // 48942797000172
  // 48942797000172

  async validateCNPJ(cnpj: string) {
    try {
      const hasByCNPJ = await api.get(`/ongs/search/${cnpj}`);

      if (hasByCNPJ?.data?.id) {
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }
}
